<template>
  <div class="manage-content">
    <div class="location">达人管理中心 / 订单详情</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <extension-status :is_success="is_success"></extension-status>
      <extension-info :task_title="task_title"
                      :money="money"
                      :task_click="task_click"
                      :order_sn="order_sn"
                      :receipt_time="receipt_time"
                      :task_receipt_time="task_receipt_time"
                      :task_time="task_time"
                      :task_url="task_url"
                      :reward_type="reward_type"></extension-info>
      <extension-completion :statistics="statistics"
                            :reward_type="reward_type"></extension-completion>
      <extension-receipt
              :list="list"
              :split_num="split_num"
              :count="count"></extension-receipt>
      <div class="repeat flex justify-content margin-top-20 margin-bottom-20">
        <el-button style="width:20%;" @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {darenTaskOrderDetail} from '@/config/api.js'
import ExtensionInfo from './components/ExtensionInfo'
import ExtensionStatus from './components/ExtensionStatus'
import ExtensionCompletion from './components/ExtensionCompletion'
import ExtensionReceipt from './components/ExtensionReceipt'
export default {
  name: 'ExtensionDetail',
  components: {
    ExtensionStatus,
    ExtensionInfo,
    ExtensionCompletion,
    ExtensionReceipt
  },
  data () {
    return {
      click_num: '',
      count: '',
      is_success: '',
      list: [],
      modify_time: '',
      money: '',
      name: '',
      order_sn: '',
      receipt_time: '',
      split_num: '',
      statistics: {
        click_num: '',
        completion_rate: '',
        income: '',
        task_click: '',
        task_result: '',
      },
      status: '',
      success_status: '',
      success_time: '',
      task_click: '',
      task_clicks: '',
      task_content: '',
      task_id: '',
      task_img: '',
      task_introduce: '',
      task_price: '',
      task_receipt_time: '',
      task_show: '',
      task_sn: '',
      task_time: '',
      task_title: '',
      task_type: '',
      task_url: '',
      type: '',
      reward_type: '',
    }
  },
  methods: {
    getOrderDetail () {
      let data = {
        id: this.$route.query.id,
        task_id: Number(this.$route.query.task_id),
        user_id: this.$store.state.user_id,
      };
      this.$post(darenTaskOrderDetail,data)
              .then(res => {
                const data = res.data;
                this.task_title = data.task_title;
                this.count = data.count;
                this.task_id = data.task_id;
                this.task_price = data.task_price;
                this.task_clicks = data.task_clicks;
                this.task_click = data.task_click;
                this.order_sn = data.order_sn;
                this.task_url = 'https://' + data.task_url;
                this.money = data.money;
                this.create_time = data.create_time;
                this.receipt_time = data.receipt_time;
                this.task_receipt_time = data.task_receipt_time;
                this.task_time = data.task_time;
                this.split_num = data.split_num;
                this.is_success = data.is_success;
                this.statistics.task_click = data.statistics.task_click;
                this.statistics.click_num = data.statistics.click_num;
                this.statistics.completion_rate = data.statistics.completion_rate;
                this.statistics.click_num = data.statistics.click_num;
                this.statistics.task_result = data.statistics.task_result;
                this.statistics.income = data.statistics.income;
                this.list.name = data.list.name;
                this.list.head_img = data.list.head_img;
                this.list.is_success = data.list.is_success;
                this.list.task_click = data.list.task_click;
                this.list.click_num = data.list.click_num;
                this.list = data.list;
                this.reward_type = data.reward_type;
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    back () {
      this.$router.go(-1);
    }
  },
  created() {
    this.getOrderDetail();
  }
}
</script>
<style scoped>
    .margin-top-20{margin-top:30px;}
</style>
